import { AppUppyFile } from "common";
import { RequiredDocumentMeta } from "../../model/application-form.model";

export interface ProgressBarDialogComponentConfig {
  filesToUpload: AppUppyFile[];
  generateEndpoint?: (meta: RequiredDocumentMeta) => string;
}

export enum ProgressBarDialogComponentResultEnum {
  Completed = 'completed',
  Canceled = 'canceled'
}
